<template>
  <div class>


    <sweet-modal ref="modal" width="900px" hide-close-button blocking>

      <p class="popup-save-title">{{ this.$t('ct-title-domain-popup') }}</p>
       <p class="popup-save-message">
        {{ this.$t('ct-message-domain-popup') }}
        </p>

        <div  class="">
          <button @click="buyDomain()" class="btn btn-primary btn-lg popup-save-btn-buy-domain">{{ this.$t('ct-buy-domain') }}</button>
        </div>
              <div class="row">
                <div class="col-12 col-md-8 col-lg-12 py-1">
                  <div class="container-accordion-form" id="accordion">
                    <div class="card mb-4">
                      <div class="card-header" id="headingSettings">
                        <span
                          class="py-1 d-block"
                          data-toggle="collapse"
                          data-target="#collapseSettings"
                          aria-expanded="true"
                          aria-controls="collapseSettings"
                        >
                         {{ this.$t('ct-i-have-domain') }}
                          <font-awesome-icon
                            :icon="['fas', 'sort-down']"
                            class="font-awesome-icon danger"
                          />
                        </span>
                      </div>
                      <div
                        id="collapseSettings"
                        class="collapse"
                        aria-labelledby="headingSettings"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <div class="form-row">

                            <div class="form-group col-12">

                              <label for="">{{ this.$t('ct-domain') }}</label>
                              <input v-model="domain.name" type="text" class="form-control">
                              <small v-if="invalid" class="text-danger">Domain Invalid</small>

                            </div>

                            <p v-html="this.$t('ct-domain-rules')">

<!--                              To connect your existing domain, follow these steps:-->
<!--                              <br>-->
<!--                              Put the domain in the field above;  <br>-->
<!--                              Wait 5 minutes for our system to register your domain;  <br>-->
<!--                              Go to  the website where your domain was purchased (godaddy, namecheap, etc);  <br>-->
<!--                              Go to settings to change Server Names (NameServers);  <br>-->
<!--                              Change NS Server to: NS3.L4DNS.COM and NS4.L4DNS.COM;  <br>-->
<!--                              DONE, now just wait for your domain to propagate on the internet, this process can take about 1 hour (in some special cases this can take up to 48 hours);  <br>-->
<!--                              Your SSL Security Certificate will be automatically added to your website within a few minutes;  <br>    <br>-->

                            </p>
                            <br>
                            <button @click="saveDomain" slot="button" class="btn btn-success mt-2 btn-publish ">{{ this.$t('ct-connected-domain') }}</button>
                        </div>
                      </div>
                    </div>


                    </div>
                  </div>
                </div>

              </div>


      <button slot="button" class="btn btn-outline-light mt-2 btn-not-now" @click="cancel"> {{ this.$t('ct-close') }}</button>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import { connect, disconnect } from '../../../js/services/editor/domain';

export default {
  props: ['show', 'id_website'],
  name: 'ModalDomain',
  components: {
    SweetModal
  },
  data() {
    return {
      domain: {
        name: '',
        region: 101
      },
     invalid: 0,
     site: {
       encrypted_id: 'eyJpdiI6IlgwVStcLzh6aWNScHZEQVRZa0o3azdRPT0iLCJ2YWx1ZSI6IlwvTWRuT0w0aUhRT2tSUTBjY0l6MmdRPT0iLCJtYWMiOiI3YTE5ODMwMDE5NWNkZTcyNzExYmI2M2E1MTFiNjY2NmJmMjJlN2ExYzdjMzMzMjk2MTAzZDhlYWM3ODIwYjlkIn0='
     }
    };
  },
  watch: {
    show: function(value) {
      if (value){
        this.$refs.modal.open();
      }
      else this.$refs.modal.close();
    }
  },
  methods: {
    cancel() {
      this.$emit('closeAction');
    },

    buyDomain(){
      var win = window.open('https://office.builderall.com/us/office/buy-domain?step=0', '_blank');
      win.focus();
    },

    saveDomain() {

      let obj = this.domain;
      obj.encrypted_id = this.id_website;

      connect(this.domain)
        .then(res => {
          let data = res.data.data;

          if (!res.data.success) {
            this.$snotify.error(res.data.error, {
              timeout: 5000
            });
          } else {
            let dns = JSON.parse(data.dns);
            if (dns.status === 'success') {
              this.$snotify.success(this.$t('ct-success-action'));
              this.$emit('updateDomain');
              this.$emit('connect');
              this.$emit('closeAction');
            } else {
              this.$snotify.error(dns.msg, {
                timeout: 5000
              });
            }
          }
        })
        .catch(error => {
          this.$loading.hide();
        });
    },
  }
};
</script>

<style lang="scss" scoped>





</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalDomain.vue